module.exports = __webpack_public_path__ + "img/step4-b.68a5debb.png";